module.exports = __webpack_public_path__ + "assets/img/img_2014.3239d8b3.jpg";